import { ButtonSecondary } from '@americanexpress/dls-react';
import { trackClick } from 'src/hooks/useAdobeTags';
import adobeTags from 'src/types/adobe-tags';
import { goToBudgetPersonalize } from 'src/services/router.service';
import Selectors from 'src/utils/selectors';
import BudgetService from 'src/services/budget.service';
import LiteralsService from 'src/services/literals/LiteralsService';
import React from 'react';
import { useUser } from 'src/hooks/queries/users';
import { UserUtils } from 'src/types/user.model';
import { useBudgets } from 'src/hooks/queries/budgets';
import { useHistory } from 'react-router-dom';

interface Props {
    location: 'top' | 'bottom';
}

export default function CategoryEditButton({ location }: Props): JSX.Element {
    const history = useHistory();
    const { data: budgets } = useBudgets();
    const { data: user } = useUser();
    const isFullPlanUser: boolean = !UserUtils.isBudgetingUser(user);
    const hasCategoryBudgets: boolean = BudgetService.getCategoryBudgets(budgets)?.length > 0;

    const getTag = (): string => {
        const isTop = location === 'top';
        if (hasCategoryBudgets && isTop) return adobeTags.CurrentMonth.Edit;
        if (hasCategoryBudgets && !isTop) return adobeTags.CurrentMonth.EditBottom;
        if (isTop) return adobeTags.CurrentMonth.CreateBudget;
        return adobeTags.CurrentMonth.CreateBudgetBottom;
    };
    return (
        <ButtonSecondary
            onClick={() => {
                trackClick(history.location.pathname, getTag());
                goToBudgetPersonalize(isFullPlanUser, history);
            }}
            role="link"
            data-cy={Selectors.SpendSmart.HOME_EDIT_BUDGET_BUTTON}
        >
            {hasCategoryBudgets
                ? LiteralsService.getLiteral('Budget.editCategoryBudget')
                : LiteralsService.getLiteral('Budget.createCategoryBudget')}
        </ButtonSecondary>
    );
}
